import React from 'react';
import cx from 'classnames';

import { TickCircleIcon, WarningIcon } from '@motorway/mw-highway-code';

import styles from './HistoryCheckIcon.module.scss';

interface HistoryCheckIconProps {
	isWarning?: boolean;
}

const HistoryCheckIcon: React.FC<HistoryCheckIconProps> = ({ isWarning = false }) => (
	<span className={cx(styles.icon, isWarning ? styles.warningIcon : styles.tickIcon)}>
		{isWarning ? <WarningIcon filled size="small" /> : <TickCircleIcon filled size="small" />}
	</span>
);

export default HistoryCheckIcon;
